import {
  FiBriefcase,
  FiCalendar,
  FiCoffee,
  FiGrid,
  FiMonitor,
  FiShoppingCart,
  FiTarget,
  FiUser,
} from "react-icons/fi";

export const websiteTypes = [
  {
    icon: FiBriefcase,
    title: "Business Websites",
    label: "For small businesses",
    text: "A professional website that explains who you are, what you offer, and why people should trust you.",
    image: "/images/website-types/business.jpg",
  },
  {
    icon: FiShoppingCart,
    title: "E-commerce Stores",
    label: "For selling products",
    text: "Online shops with product pages, catalogue structure, stock-friendly setup, and payment-ready direction.",
    image: "/images/website-types/e-commerce.jpg",
  },
  {
    icon: FiTarget,
    title: "Landing Pages",
    label: "For campaigns",
    text: "Focused one-page websites for ads, launches, lead generation, special offers, or event promotion.",
    image: "/images/website-types/landing-page.jpg",
  },
  {
    icon: FiCalendar,
    title: "Booking Websites",
    label: "For appointments",
    text: "Websites for businesses that need people to book sessions, request appointments, or send enquiries.",
    image: "/images/website-types/booking.jpg",
  },
  {
    icon: FiGrid,
    title: "Catalogue & Menu Sites",
    label: "For easy updates",
    text: "Digital catalogues, restaurant menus, service lists, or product showcases that are simple to update.",
    image: "/images/website-types/catalog.jpg",
  },
  {
    icon: FiUser,
    title: "Portfolio & Personal Brand Sites",
    label: "For individuals",
    text: "Clean websites for freelancers, creators, consultants, students, or professionals who want to present their work.",
    image: "/images/website-types/portfolio.jpg",
  },
  {
    icon: FiCoffee,
    title: "Restaurant & Local Shop Sites",
    label: "For local businesses",
    text: "Simple but polished websites for cafés, restaurants, salons, studios, stores, or local services.",
    image: "/images/website-types/restaurant.jpg",
  },
  {
    icon: FiMonitor,
    title: "Simple Web Apps",
    label: "For custom workflows",
    text: "Lightweight internal tools like dashboards, admin panels, forms, catalogues, or business workflows.",
    image: "/images/website-types/dashboard.jpg",
  },
];
